module.exports = "/assets/data/f559ad884d6deecb189613b238853fa3-RG40.data.json";